import type { FaireProductEntity } from "../../entity_types/product";

export const p_usk589escg: FaireProductEntity = {
  token: "p_usk589escg",
  type: "product",
  name: "Organic Sun-opener Loose Leaf Tea",
  brandToken: "b_bqcgv7uqrr",
  brandName: "Healing Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/bf683299d41f5eb2405c7a7dc4db3b1cf2a28b5614c1d9f050f2b1f4c72d84e7.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.93,
  description:
    "\nOrganic Sun-Opener Loose Leaf Tea\n\nDive into the revitalizing experience of Healing Herbals' Organic Sun-Opener Loose Leaf Tea. Sourced from the finest organic Sun-opener herbs, this tea is celebrated for its invigorating properties and its capacity to enhance clarity and spiritual awareness. Perfect for those mornings when you need a natural boost or moments of meditation, our Sun-Opener Tea is your gateway to heightened focus and a deeper connection with your surroundings.\n\nProduct Highlights:\n\n * Ingredients: 100% organic Sun-opener leaves \n * Benefits: Aids in enhancing mental clarity, supports spiritual awareness, and provides an uplifting effect \nBrewing Instructions: Steep one teaspoon of our Organic Sun-Opener Loose Leaf Tea in hot water for 5-7 minutes.",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:58.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
